import { render, staticRenderFns } from "./LayoutsMoodRedSection.vue?vue&type=template&id=8805bbf6"
import script from "./LayoutsMoodRedSection.vue?vue&type=script&lang=ts"
export * from "./LayoutsMoodRedSection.vue?vue&type=script&lang=ts"
import style0 from "./LayoutsMoodRedSection.vue?vue&type=style&index=0&id=8805bbf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports